// import { PRODUCTS } from "../data/products";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ProductCard from "../components/ProductCard/ProductCard";
import products from "../data/products";
import "./pages.css";

export default function ProductsPage() {
  const [category, setCategory] = useState("tshirts");
  const catData = products[category];

  const navigate = useNavigate();

  const onProductClickForPage = (id) => {
    try {
      navigate(`/products/${id}`);
    } catch (e) {
      console.log("Error occured", e);
    }
  };

  return (
    <div className="page products-page">
      <p className="section-title ">THE COLLECTION</p>
      <h1 className="big-title ">PRODUCTS</h1>
      <div className="prodCategoryGrid">
        {Object.entries(products).map(([k, c]) => (
          <div
            key={k}
            onClick={() => setCategory(k)}
            className={`categoryItem ${category === k ? "active" : ""}`}
          >
            <p
              className="categoryLabel"
              style={{ color: category === k ? "#0a0a0a" : "#888" }}
            >
              {c.label}
            </p>
          </div>
        ))}
      </div>
      <div className="productGrid">
        {catData.items.map((p) => (
          <ProductCard key={p.id} product={p} onClick={onProductClickForPage} />
        ))}
      </div>
    </div>
  );
}
